const socialOrigin = window.location.origin

export default {
  providers: {
    google: {
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      redirectUri: `${socialOrigin}/auth/google/callback`,
    },
    facebook: {
      clientId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
      redirectUri: `${socialOrigin}/auth/facebook/callback`,
    },
    microsoft: {
      clientId: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
      redirectUri: `${socialOrigin}/auth/microsoft/callback`,
      authorizationEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
      name: 'microsoft',
      url: '/auth/oauth2',
      display: 'popup',
      oauthType: '2.0',
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display'],
      scope: ['User.Read'],
      scopeDelimiter: ' ',
      popupOptions: { width: 500, height: 560 },
    },
    apple: {
      clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
      redirectUri: `${socialOrigin}/auth/apple/callback`,
      authorizationEndpoint: 'https://appleid.apple.com/auth/authorize',
      name: 'apple',
      url: '/auth/apple',
      display: 'popup',
      oauthType: '2.0',
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display', 'response_mode'],
      scope: ['name', 'email'],
      responseMode: 'form_post',
      scopeDelimiter: ' ',
      popupOptions: { width: 500, height: 560 },
      responseType: 'code',
    },
  },
}
